import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, CardMedia } from "@mui/material";

import { Videos, ChannelCard } from "./";
import { fetchFromAPI } from "../utils/fetchFromAPI";

const ChannelDetail = () => {
  const [channelDetail, setChannelDetail] = useState();
  const [videos, setVideos] = useState(null);

  const { id } = useParams();

  useEffect(() => {
    const fetchResults = async () => {
      const data = await fetchFromAPI(`channel/details/?id=${id}`);

      console.log(data);
      setChannelDetail(data);
      if (channelDetail?.title) {
        const videosData = await fetchFromAPI(
          `search/?q=${channelDetail.title}&hl=en&gl=ES`
        );
        setVideos(videosData?.contents);
      }

      
    };

    fetchResults();
  }, [id]);

  return (
    <Box minHeight="95vh">
      <Box>
        {channelDetail ? (
          <CardMedia
            image={channelDetail?.banner?.desktop[3]?.url}
            alt={channelDetail?.title}
            sx={{
              height: "300px",
              zIndex: 10,
            }}
          />
        ) : (
          <div
            style={{
              background:
                "linear-gradient(90deg, rgba(0,238,247,1) 0%, rgba(206,3,184,1) 100%, rgba(0,212,255,1) 100%)",
              zIndex: 10,
            }}
          />
        )}

        <ChannelCard channelDetail={channelDetail} marginTop="-133px" />
      </Box>
      <Box p={2} display="flex">
        <Box sx={{ mr: { sm: "100px" } }} />
        <Videos videos={videos} />
      </Box>
    </Box>
  );
};

export default ChannelDetail;
